import React, { useEffect, useState } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import './Refiller.css';
import axios from "axios";
import { Cookies } from "react-cookie";
import { Link, useNavigate } from "react-router-dom";
import Loading from "../Loading";
import { ErrorAlert, SuccessAlert } from "../middleware/AlertMsg";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,TablePagination
} from '@mui/material';
import {HeaderTableCell,StyledTableRow,StyledTableCell} from '../Partials/TableStyle'
const Manage_Refill_Request = () => {
  const cookies = new Cookies();
  const token = cookies.get('JWTcookie');
  const [request, setRequest] = useState([])
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();
  // const baseUrl='https://busy-erin-raven-vest.cyclic.app';
  //const baseUrl = "https://officejeeves.com";
  const baseUrl =  process.env.REACT_APP_BASE_URL;
  
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchQuery, setSearchQuery] = useState("");

  const getRequests = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${baseUrl}/api/allrefillingrequest?status=Pending`, { headers: { 'Authorization': 'Bearer ' + token } })
      const data = res.data?.data;
      // console.log('data: ', data);
      const sortedData=data.sort((a,b)=>{
        return new Date(b.date) - new Date(a.date)
      })
      setRequest(sortedData);
      setLoading(false)
    } catch (error) {
      // console.log(error);
      ErrorAlert({
        title: "Fail",
        message: error.message,
    });
    }
  }
// console.log('Requests:',request)
  useEffect(() => {
    getRequests();
  }, []);
  // table related functions
  useEffect(() => {
    // Reset page to 0 after a search
    setPage(0);
  }, [searchQuery]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredData = request.filter((item) => {
    return Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(searchQuery.toLowerCase());
  });
 // end table related functions
  const setFormat = (dateString) => {
    const date = new Date(dateString);
    const formattedDate = date.toLocaleString();
    return formattedDate;
  }
  // console.log("request", request)

  const handleDelete = async (id) => {
    const shouldDelete = window.confirm("Are you sure to delete this item ?");
    // console.log('shouldDelete: ', shouldDelete);
    if (!shouldDelete) {
      return;
    }
    try {
      setLoading(true)
      // Make an API call to delete the request based on the id
      await axios.delete(`${baseUrl}/api/refillrequest/${id}`, {
        headers: { 'Authorization': 'Bearer ' + token }
      });

      // Update the state to remove the deleted request from the list
      setRequest((prevRequests) => prevRequests.filter(item => item.refillingRequestNumber !== id));
      SuccessAlert({
        title: "Success",
        message: "Request Deleted successfully",
      });
      setLoading(false)
    } catch (error) {
      ErrorAlert({
        title: "Delete Failed",
        message: error.message,
      });
      setLoading(false)
    }
  };

  return (
    <div  className="table_container-div">
      {isLoading ? <Loading /> :
       request.length === 0 ?
       <div style={{
           width: "90%", display: 'flex', margin: "auto", justifyContent: 'Center', marginTop: "40px",
           backgroundColor: "black", color: "white", padding: "7px"
       }}>
           <p>No Data Found</p>
       </div>
       :
        <div> 

            <button className="refillerbackbtn" onClick={() => navigate(-1)}>Back</button>
          <div>
            <h3>Manage Re-fill Request Lists</h3>
          </div>
          <div>
          <div className="search-div">
            <label>Search : </label>
            <input
              value={searchQuery}
              onChange={handleSearch}
              variant="outlined"
              size="small"
              // className="search-field"
            />
          </div>
          <TableContainer component={Paper}>
            <Table>
            <TableHead>
              <StyledTableRow>
                  <HeaderTableCell>Sr.No</HeaderTableCell>
                  <HeaderTableCell>Date</HeaderTableCell>
                  <HeaderTableCell>Request No</HeaderTableCell>
                  <HeaderTableCell>Refiller Name</HeaderTableCell>
                  <HeaderTableCell>Machine Name</HeaderTableCell>
                  <HeaderTableCell>WareHouse</HeaderTableCell>
                  <HeaderTableCell>Status</HeaderTableCell>
                  <HeaderTableCell>Actions</HeaderTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {
                  filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item,index) =>  (
                    <StyledTableRow key={item.id} sx={{
                      backgroundColor: index % 2 === 0 ? '#f5f5f5' : 'white',
                    }}>
                      <StyledTableCell>{index + 1}</StyledTableCell>
                      <StyledTableCell>{setFormat(item.date)}</StyledTableCell>
                      <StyledTableCell>{item.refillingRequestNumber}</StyledTableCell>
                      <StyledTableCell>{item.refillerName}</StyledTableCell>
                      <StyledTableCell>{item.machineName}</StyledTableCell>
                      <StyledTableCell>{item.warehouseName}</StyledTableCell>
                      <StyledTableCell>
                        <div
                          style={{ display: 'flex', justifyContent: 'center' }}
                        >
                          <div
                            style={{
                              backgroundColor: item.status === "Pending" ? "red" : "green",
                              padding: '5px',
                              width: '4px',
                              height: "4px",
                              borderRadius: "100%",
                            }}
                          >
                          </div>
                        </div>
                      </StyledTableCell>
                      <StyledTableCell >
                        <div className="actionsBtn">
                          <Link to={`/refillermanager/managerefillrequest/${item._id}`}>
                            <FaEdit />
                          </Link>
                          <FaTrash
                            onClick={() => handleDelete(item.refillingRequestNumber)}
                          />
                        </div>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))
                }
              </TableBody>
            </Table>
            <TablePagination
               rowsPerPageOptions={[10, 25, 50, 100]}
               component="div"
               count={filteredData.length}
               rowsPerPage={rowsPerPage}
               page={page}
               onPageChange={handleChangePage}
               onRowsPerPageChange={handleChangeRowsPerPage}
            />
           
            </TableContainer>
          </div>
        </div>
      }
    </div>
  );
}

export default Manage_Refill_Request;